// extracted by mini-css-extract-plugin
export default {"mainIcon":"XShareLink_mainIcon__7h3A9"};